var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4661 9.19971H11.0661C10.0352 9.19971 9.19946 10.0354 9.19946 11.0664V19.4664C9.19946 20.4973 10.0352 21.3331 11.0661 21.3331H19.4661C20.4971 21.3331 21.3328 20.4973 21.3328 19.4664V11.0664C21.3328 10.0354 20.4971 9.19971 19.4661 9.19971Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46675 14.7998H4.53341C4.03834 14.7998 3.56355 14.6031 3.21348 14.2531C2.86341 13.903 2.66675 13.4282 2.66675 12.9331V4.53317C2.66675 4.0381 2.86341 3.5633 3.21348 3.21324C3.56355 2.86317 4.03834 2.6665 4.53341 2.6665H12.9334C13.4285 2.6665 13.9033 2.86317 14.2533 3.21324C14.6034 3.5633 14.8001 4.0381 14.8001 4.53317V5.4665",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0db7beacc725729b1711320323d8a466.svg";
export { ForwardRef as ReactComponent };